







































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import {BIcon, BIconBoxArrowRight} from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIconBoxArrowRight,
    BIcon,
    NextPrevBtn,
    Footer,
  },
})
export default class OnlineCultureGeneral extends Vue {
 protected nxtprevOnlineCultureCinema =
  {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail7.png",
    NextImage: "/thumbnail2.png",
    PrevLink: "/CultureenLigne/Sciences",
    NextLink: "/CultureenLigne/MediaPresse",
  };
}
